<template>
  <c-button
    left-icon="location"
    variation="solid"
    background="brand.beige"
    border-color="brand.beige"
    @click="onClickTrackingLink(returnListing, rmaId)"
  >
    {{ $t("productReturn.trackTheShipment") }}
  </c-button>
</template>

<script lang="ts">
import { CButton } from "@chakra-ui/vue";
import { getReturnType, isMaintenanceReturn, ShipperType, IRootState } from "@iloq/shared";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "RMAParcelTrackingLink",
  components: {
    CButton,
  },
  props: {
    rmaId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      returnListing: (state: unknown) => (state as IRootState).returns?.list,
    }),
  },
  methods: {
    getTrackingCodesForSalesAndCampaignReturn(shipperType, parcels) {
      switch (shipperType) {
        case ShipperType.POSTI:
          return (parcels || []).map(({ parcelNo }) => parcelNo);
        case ShipperType.UPS:
          return (parcels || []).map(({ trackingNumber }) => trackingNumber);
        case ShipperType.DHL:
          return (parcels || []).map(({ trackingNumber }) => trackingNumber);
        default:
          throw new Error(
            `getTrackingCodesForSalesAndCampaignReturn: Unsupported shipperType ${shipperType}`,
          );
      }
    },
    getTrackingUrl(shipperType, trackingCodes) {
      switch (shipperType) {
        case ShipperType.POSTI:
          return `https://www.posti.fi/fi/seuranta#/lahetys/${trackingCodes.join("%2C")}`;
        case ShipperType.UPS:
          return `https://www.ups.com/track?loc=en_FI&tracknum=${trackingCodes.join("%0D%0A")}`;
        case ShipperType.DHL:
          return `https://www.dhl.com/us-en/home/tracking.html?tracking-id=${trackingCodes.join(
            "%2C",
          )}`;
        default:
          throw new Error(`getTrackingUrl: Unsupported shipperType ${shipperType}`);
      }
    },
    onClickTrackingLinkMaintenanceReturn({ shipmentDetails: { shipperType, trackingCodes } }) {
      const url = this.getTrackingUrl(shipperType, trackingCodes);
      window.open(url, "_blank");
    },
    onClickTrackingLinkSalesOrCampaignReturn({ shipperType, parcels }) {
      const trackingCodes = this.getTrackingCodesForSalesAndCampaignReturn(shipperType, parcels);
      const url = this.getTrackingUrl(shipperType, trackingCodes);
      window.open(url, "_blank");
    },
    onClickTrackingLink(returnListing, rmaId) {
      const returnItem = returnListing.find((item) => item.rmaId === rmaId);
      const returnType = getReturnType(returnItem);

      if (isMaintenanceReturn(returnType)) {
        this.onClickTrackingLinkMaintenanceReturn(returnItem);
      } else {
        this.onClickTrackingLinkSalesOrCampaignReturn(returnItem);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../../design-system/assets/tokens/tokens";

a.parcel-link {
  display: table;
  cursor: pointer;
  .icon {
    margin: 0 0;
    padding: 0;
    display: table-cell;
    vertical-align: middle;
    svg {
      width: 16px;
      height: 16px;
      fill: $color-iloq-blue-light !important;
    }
  }
  span {
    display: table-cell;
    padding: 0 10px 0 0;
    font-size: 16px;
    color: $color-iloq-blue-light;
    font-weight: 0;
  }
  &:hover {
    .icon svg {
      fill: $color-iloq-green !important;
    }
    span {
      color: $color-iloq-green !important;
    }
  }
}
a.parcel-button {
  color: white !important;
  &:hover {
    color: white !important;
  }
}
</style>
